<template>
  <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
      <a class="nav-link active" id="v-pills-Personal-tab" data-toggle="pill" href="#v-pills-Personal" role="tab" aria-controls="v-pills-Personal" aria-selected="true">Personal Data</a>
      <a class="nav-link" id="v-pills-Parent-tab" data-toggle="pill" href="#v-pills-Parent" role="tab" aria-controls="v-pills-Parent" aria-selected="false">Parent Info</a>
      <a class="nav-link" id="v-pills-Contact-tab" data-toggle="pill" href="#v-pills-Contact" role="tab" aria-controls="v-pills-Contact" aria-selected="false">Contact Info</a>
      <a class="nav-link" id="v-pills-Education-tab" data-toggle="pill" href="#v-pills-Education" role="tab" aria-controls="v-pills-Education" aria-selected="false">Education History</a>
      <a class="nav-link" id="v-pills-Attachments-tab" data-toggle="pill" href="#v-pills-Attachments" role="tab" aria-controls="v-pills-Attachments" aria-selected="false">Attachments</a>
      <a class="nav-link" id="v-pills-Preferences-tab" data-toggle="pill" href="#v-pills-Preferences" role="tab" aria-controls="v-pills-Preferences" aria-selected="false">Preferences</a>
      <a class="nav-link" id="v-pills-Terms-tab" data-toggle="pill" href="#v-pills-Terms" role="tab" aria-controls="v-pills-Terms" aria-selected="false">Terms and Conditions</a>
      <!-- <a class="nav-link" id="v-pills-Payment-tab" data-toggle="pill" href="#v-pills-Payment" role="tab" aria-controls="v-pills-Payment" aria-selected="false">Payment</a> -->
      <a class="nav-link" id="v-pills-MyApplication-tab" data-toggle="pill" href="#v-pills-MyApplication" role="tab" aria-controls="v-pills-MyApplication" aria-selected="false">View Application</a>
    </div>

</template>

<script>

export default {
        name: 'Tap' ,

        computed: {
            currentUser() {
            return this.$store.state.auth.user;
            }
        },
        created(){
         this.$emit('clickec', 'Application')
        }
    }
</script>

<style scoped>
body{
    background: #007bff0a !important;
}
.nav-pills .nav-link.active, .nav-pills .show>.nav-link {
    color: #00A1D5;
    background-color: none !important;
    border-bottom: 1px #646464 dotted;
}
.nav-pills .nav-link.active, .nav-pills .show>.nav-link {
    color: #fff;
 background-color: #007bff0a;;
}

.nav-pills .nav-link {
    border-radius: .1rem;
    border-bottom: 1px #646464 dashed;
    color: #285475;
    font-size: 17px;

}
.nav-pills .nav-link.active, .nav-pills .show>.nav-link {
    color: #fff;
    background-color: #285475 !important;
}
</style>